import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';
// import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import { useAppSelector } from '../../../../redux/hooks';
import LocationSidePanel from '../../../../shared-components/table-side-panel/LocationSidePanel';
import SidePaneModel from '../../../../shared-components/table-side-panel/SidePaneModel';
import TabsContainer from '../../../../shared-components/tabs-container/TabsContainer';
import AddLocation from '../../location-management/components/AddLocation';
import LocationDevicesLane from '../location-dashboard/LocationDevicesLane';

import { LocationDetailsLeft, LocationDetailsRight } from './location-details/LocationDetails';
import LocationManagementBottomContainer from './location-details/LocationManagementBottomContainer';

/**
 * Station Dashboard
 * @returns {any} The rendered component
 */
function LocationDashboard() {
  const { t, i18n } = useTranslation('sidePanel');
  const [openTab, setOpenTab] = useState(0);
  const [editStationOpen, setEditStationOpen] = useState(false);
  const [addStationOpen, setAddLocationOpen] = useState(false);
  const { selectedChargingPoint } = useAppSelector((state) => state.locationManagement);

  const containerTabs = [
    {
      label: t('lane'),
      key: 'lane',
      isActive: openTab === 0,
    },
    {
      label: t('media'),
      key: 'media',
      isActive: openTab === 1,
    },
    {
      label: t('amenities'),
      key: 'amenities',
      isActive: openTab === 2,
    },
  ];

  /**
   * Function to switch tab
   * @param {string} key - The selected tab key
   */
  const handleSwitchTab = (key: string) => {
    if (key === 'lane') {
      setOpenTab(0);
    } else if (key === 'media') {
      setOpenTab(1);
    } else if (key === 'amenities') {
      setOpenTab(2);
    }
  };

  return (
    <div className="location-dashboard-container" dir={i18n.dir()}>
      <div className="location-devices">
        <div className="left">
          <LocationDetailsLeft />
        </div>
        <div className="right">
          <TabsContainer containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />

          <div className="tab-content-container">
            {openTab === 0 && <LocationDevicesLane />}
            {openTab === 1 && <LocationDetailsRight showTabs={false} defaultTab="media" />}
            {openTab === 2 && <LocationDetailsRight showTabs={false} defaultTab="amenities" />}
          </div>
        </div>
      </div>
      <LocationManagementBottomContainer />
      <SidePaneModel
        open={addStationOpen}
        closePanel={() => setAddLocationOpen(false)}
        content={
          <AddLocation
            onClose={() => setAddLocationOpen(false)}
            onSuccess={() => {
              setAddLocationOpen(false);
              // Handle refresh if necessary
            }}
          />
        }
        position="right"
        title="addStation"
      />
      <SidePaneModel
        open={editStationOpen}
        closePanel={() => setEditStationOpen(false)}
        content={
          <LocationSidePanel
            fetchIdFrom="props"
            id={selectedChargingPoint?.id as string}
            initialIsEditMode
            onEditModeChange={(isEditMode: any) => {
              if (!isEditMode) {
                setEditStationOpen(false);
              }
            }}
            onClose={() => setEditStationOpen(false)}
            onDeleteStation={() => {}}
            onSuccess={() => window.location.reload()}
          />
        }
        position="right"
        hideHeader
      />
    </div>
  );
}

export default LocationDashboard;
